import { computed, type ComputedRef, type Ref } from 'vue';
import { IButtonProps as IButtonPropsOriginal, ICommonEmits } from '@/types/components/buttons';

interface IButtonProps {
  ariaLabel?: Ref<IButtonPropsOriginal['ariaLabel']>;
}

interface IUseButtonReturn {
  computedAriaLabel: ComputedRef<string>;
  handleClick: (event: MouseEvent) => void;
  handleKeyDownEnter: (event: KeyboardEvent) => void;
  handleKeyUpSpace: (event: KeyboardEvent) => void;
}

export function useButton(props: IButtonProps, emits?: ICommonEmits) {
  const { ariaLabel } = props;

  const computedAriaLabel = computed((): string => ariaLabel?.value || '');

  const handleClick = (event: MouseEvent): void => {
    if (!emits) return;

    emits('click', event);
  };
  const handleKeyDownEnter = (event: KeyboardEvent): void => {
    if (!emits) return;

    emits('keydown.enter', event);
  };
  const handleKeyUpSpace = (event: KeyboardEvent): void => {
    if (!emits) return;

    emits('keyup.space', event);
  };

  return <IUseButtonReturn>{
    computedAriaLabel,
    handleClick,
    handleKeyDownEnter,
    handleKeyUpSpace
  };
}